import { render, staticRenderFns } from "./GenerationUnitsFeedbackFormGroup.vue?vue&type=template&id=58dd2bba&"
import script from "./GenerationUnitsFeedbackFormGroup.vue?vue&type=script&lang=ts&"
export * from "./GenerationUnitsFeedbackFormGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports